module.exports = __webpack_public_path__ + "static/img/slogan.e9ddb5ea.png";